module.exports = __webpack_public_path__ + "img/payment.1cf9d99d.svg";